import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Card from "shared/components/Card";
import Header from "shared/components/Header";
import Spin from "shared/components/Spin";
import { useQuery } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import graphql from "utils/api/graphql";
import { SCREENS } from "utils/constants";
import View from "./View";

const List = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS);
  const LIST = t("LIST", { returnObjects: true });
  const navigate = useNavigate();
  const [pagination, setPagination] = useState({ skip: 0, take: 25 });

  const { data, loading } = useQuery(graphql.queries.DOCUMENT_TEMPLATES, {
    variables: {
      ...pagination,
    },
    fetchPolicy: "network-only",
  });

  const templates = data?.documentTemplates?.data || [];
  const count = data?.documentTemplates?.count || 0;

  return (
    <>
      <Header
        title={LIST.HEADER.TITLE}
        actions={[
          {
            text: LIST.HEADER.CREATE,
            onClick: () =>
              navigate(SCREENS.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS.CREATE.path),
            type: "primary",
          },
        ]}
      />
      <Card type="simple">
        {loading ? (
          <Spin />
        ) : (
          <View
            data={templates}
            count={count}
            setValues={setPagination}
            skip={pagination.skip}
          />
        )}
      </Card>
    </>
  );
};

export default List;
